import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';

export function saveInLocalStorage(key: string, value: ICalendarData[]) {
    try {
        localStorage[key] = JSON.stringify(value);
    } catch (error) {
        console.log(error);
    }
}

export function existInLocalStorage(key: string): boolean {
    // eslint-disable-next-line no-prototype-builtins
    return localStorage.hasOwnProperty(key) && localStorage[key] !== null && localStorage[key] !== 'undefined';
}

function getFromLocalStorage(key: string): ICalendarData[] {
    return JSON.parse(localStorage[key]);
}

export function tryGetFromLocalStorage(key = 'default'): ICalendarData[] {
    return existInLocalStorage(key) ? getFromLocalStorage(key) : [];
}
